const services = [
  {
    icon: '◈',
    title: 'Incorporation Services',
    desc: 'Of Private Limited Companies, Limited Liability Partnerships (LLP), Partnership Firms & Trusts. Our services include business structure advisory, initial registrations & post-incorporation compliance guidance',
  },
  {
    icon: '◉',
    title: 'Virtual CFO services',
    desc: 'Strategic and Financial advisory including budgeting, MIS reporting and other leadership support for sustainable business growth',
  },
  {
    icon: '◇',
    title: 'Business Support Services',
    desc: 'Compliance management, SOP design and internal control framework design, implementation services with end to end support to ensure smooth business operations.',
  },
  {
    icon: '◎',
    title: 'Startup & SME advisory',
    desc: 'Funding readiness, financial structuring and governance support to help raise capital and grow sustainably',
  },
  {
    icon: '◈',
    title: 'Taxation services',
    desc: 'Direct Taxation (Income Tax) advisory & compliance which includes preparation and filing of India and US Tax Returns (Individual, Firms, Trusts & Companies) & TDS filing. Indirect Taxation (GST) advisory & compliance which includes preparation and filing of Monthly & Annual Returns',
  },
  {
    icon: '◉',
    title: 'Litigation Support',
    desc: 'We provide comprehensive advisory and representation in investigations, adjudication proceedings, appeals and writ petitions',
  },
  {
    icon: '◇',
    title: 'Book-keeping Services & Financing assistance',
    desc: 'We provide comprehensive book-keeping services for business and individuals including US book-keeping. Preparation of detailed project reports for financing.',
  },
  {
    icon: '◎',
    title: 'Audit & Assurance',
    desc: 'Internal Audit, Statutory Audit, Audit under specific laws, Stock Audit, Management & Performance Audit conducted in accordance with applicable auditing standards and professional ethics. Certification and attest services in line with prescribed standards.',
  },
];

export function Services() {
  return (
    <section className="services" id="services">
      <div className="section-header">
        <p className="section-eyebrow">What We Do</p>
        <h2 className="section-title">Services crafted<br /><em>for every need</em></h2>
      </div>
      <div className="services__grid">
        {services.map((s, i) => (
          <div className="service-card" key={i}>
            <span className="service-card__icon">{s.icon}</span>
            <h3 className="service-card__title">{s.title}</h3>
            <p className="service-card__desc">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
